module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"noMessages":"Scrivi direttamente per qualsiasi chiarimento","noMessagesNutritionist":"Scrivi direttamente al paziente per qualsiasi chiarimento","noMessagesPatient":"Scrivi direttamente al nutrizionista per qualsiasi chiarimento","maxFileSizeExceeded":"Uno o più file selezionati superano la dimensione massima di {maxSize} MB"}}')
  delete Component.options._Ctor
}
